import Axios, * as others from 'axios';
import URL from '../../Environment';
import IMGPATHS from '../../ImgPaths';
import React, { Component,useEffect, useState } from "react";
import './advertise.css';
import { format } from "date-fns";
import { Link } from 'react-router-dom';

const Advertise = () => {
  const [AdvertiseData, setAdvertiseData] = useState([]);
  const [AdvertiseLoan, setAdvertiseLoading] = useState(true);
  const [errorAdvertise, setAdvertiseError] = useState(null);

  useEffect(() => {

    const fetchAdvertiseData = async () => {

          Axios.get(URL + `api/Advertise/GetAdvertise`).then((response) => {
            const res = response.data;
            //console.log(res);
    
            setAdvertiseData(response.data);
            setAdvertiseLoading(false);   
    
          }).catch((error) => {
            setAdvertiseError(error);
            setAdvertiseLoading(false); 
    
          });
      };
    
      // เรียกใช้งาน fetchData เมื่อค่าตัวแปร count มีการเปลี่ยนแปลง
      fetchAdvertiseData();

      // Cleanup function ที่จะถูกเรียกเมื่อ component ถูก unmount
      return () => {
        // ทำการคืนการทำงานที่ต้องการ (cleanup)
        //console.log('Component unmounted');
      };

  }, []);

  if (AdvertiseLoan) {
      return <div>Loading...</div>;
  }

  if (errorAdvertise) {
      return <div>Error: {errorAdvertise.message}</div>;
  }

  return (
    <div>
      <section className="breadcrumbs">
        <div className="container">
          <div className="row">
            <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
              <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link>&nbsp;
              <i className="fa fa-angle-right" />&nbsp;<a href="advertise" className="a-breadcrumbs">ข่าวประชาสัมพันธ์</a>
            </div>
          </div>
        </div>
      </section>
      <section id="services" className="services section">
        <div className="container section-title">
          <h2>ข่าวประชาสัมพันธ์</h2>
        </div>
        <div className="container" >
          <div className="row gy-5">

          {
            AdvertiseData.map((adv) => (
              <div key={adv.id} className="col-xl-4 col-md-6">
                <div className="service-item">
                  <div className="img">
                    <img src={`${IMGPATHS}` + `Img/Advertise/${adv.id}/${adv.img}`} className="img-fluid" alt={adv.topic} />
                  </div>
                  <div className="details position-relative">
                    <div className="icon">
                      <i className="bi bi-broadcast" />
                    </div>
                      <a href={`AdvertiseDetail/` + adv.id} target='_blank' className="stretched-link">
                        <h3>{adv.topic}</h3>
                        {/* <p style={{fontSize:'20px'}}>{adv.description}</p> */}
                        {/* <p style={{fontSize:'18px'}}>By {adv.update_by}, Post On {format(new Date(adv.update_day), "d MMMM, yyyy")}</p> */}
                      </a>
                    </div>
                  </div>
              </div>

              ))
            }
                              
          </div>
        </div>
      </section>

    </div>
  );
}

export default Advertise;
